const ACCENT_MAPPING = {
"à": "a", "á": "a", "ä": "a","â": "a",
"è": "e", "é": "e", "ë": "e", "ê": "e",
"ì": "i", "í": "i", "ï": "i", "î": "i",
"ò": "o", "ó": "o", "ö": "o", "ô": "o",
"ù": "u", "ú": "u", "ü": "u", "û": "u",
"ñ": "n",
"ç": "c",
"·": "-", "/": "-", "_": "-", ",": "-", ":": "-", ";": "-", " ": '-'
};

function charIsSluggable(c) {
    if (c === '-') return true;

    let code = c.charCodeAt(0);
    /* eslint-disable */
    return (code > 47 && code < 58) || // numeric (0-9)
           (code > 64 && code < 91) || // upper alpha (A-Z)
           (code > 96 && code < 123); // lower alpha (a-z)
    /* eslint-enable */
}

export function slugify(str) {
    if (!str) return null;

    str = str.trim();

    if (str.length === 0) return null;

    str = str.toLowerCase();

    let newstr = "";
    let prev = null;

    // remove accents & prevent duplicate dashes
    for (let i = 0; i < str.length; i++) {
        let c = str[i];

        // Remove accents & dashify `c`
        let n = ACCENT_MAPPING[c];
        if (n) c = n;

        // Skip things that aren't slugs
        if (!charIsSluggable(c)) continue;
        if (prev === '-' && c === '-') continue;

        // Append
        newstr += c;
        prev = c;
    }

    return newstr;
}

